/**
 * Branding typography from Settings (JSON on branding.company_*_style keys).
 * Safe for API objects or raw JSON strings.
 */
export function parseBrandingStyle(raw) {
  if (raw == null) return null;
  let o = raw;
  if (typeof raw === 'string') {
    const t = raw.trim();
    if (!t || t === '{}') return null;
    try {
      o = JSON.parse(raw);
    } catch {
      return null;
    }
  }
  if (!o || typeof o !== 'object') return null;
  const out = {};
  if (typeof o.color === 'string' && o.color.trim()) out.color = o.color.trim().slice(0, 200);
  if (typeof o.fontFamily === 'string' && o.fontFamily.trim()) {
    out.fontFamily = o.fontFamily.trim().slice(0, 500);
  }
  if (o.fontWeight != null && o.fontWeight !== '') {
    const n = Number(o.fontWeight);
    if (!Number.isNaN(n) && n >= 100 && n <= 900) out.fontWeight = n;
  }
  if (o.fontStyle === 'italic' || o.fontStyle === 'normal') out.fontStyle = o.fontStyle;
  if (typeof o.letterSpacing === 'string' && o.letterSpacing.trim()) {
    out.letterSpacing = o.letterSpacing.trim().slice(0, 32);
  }
  if (typeof o.fontSize === 'string' && o.fontSize.trim()) {
    out.fontSize = o.fontSize.trim().slice(0, 32);
  }
  return Object.keys(out).length ? out : null;
}

/** Maps parsed style to MUI `sx` fragment (no side effects). */
export function sxFromBrandingStyle(style) {
  if (!style) return {};
  const sx = {};
  if (style.color) sx.color = style.color;
  if (style.fontFamily) sx.fontFamily = style.fontFamily;
  if (style.fontWeight != null) sx.fontWeight = style.fontWeight;
  if (style.fontStyle === 'italic' || style.fontStyle === 'normal') sx.fontStyle = style.fontStyle;
  if (style.letterSpacing) sx.letterSpacing = style.letterSpacing;
  if (style.fontSize) sx.fontSize = style.fontSize;
  return sx;
}

/**
 * Merge saved branding text style into base title `sx`. When `style.color` is set,
 * gradient text-fill props from `baseSx` are omitted so a solid color shows.
 */
export function mergeBrandingTitleSx(baseSx, style) {
  const extra = sxFromBrandingStyle(style);
  if (!style || !Object.keys(extra).length) return baseSx;
  if (extra.color) {
    const { background, WebkitBackgroundClip, WebkitTextFillColor, ...restBase } = baseSx;
    return { ...restBase, ...extra };
  }
  return { ...baseSx, ...extra };
}

/** Defaults for public front page / login. */
export const DEFAULT_PUBLIC_TAGLINE_STYLE = {
  color: '#1e3a8a',
  fontFamily: 'Georgia, Cambria, "Times New Roman", serif',
  fontWeight: 600,
  fontStyle: 'italic',
  fontSize: '1.12rem',
  letterSpacing: '0.035em'
};

/** Defaults for in-app sidebar (light backgrounds need darker text). */
export const DEFAULT_APP_TAGLINE_STYLE = {
  color: '#0f172a',
  fontFamily: 'Georgia, Cambria, "Times New Roman", serif',
  fontWeight: 600,
  fontStyle: 'italic',
  fontSize: '0.95rem',
  letterSpacing: '0.02em'
};
